import {createStrokeSVG} from './TEMPLATE'

// tabler: device-imac
export const Macintosh_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12',
    'M3 13h18',
    'M8 21h8',
    'M10 17l-.5 4',
    'M14 17l.5 4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
